import React from 'react';
import { Mic, GraduationCap } from 'lucide-react';
import { mockData } from '../mock';

const MediaInteractions = () => {
  return (
    <section className="bg-gradient-to-b from-black via-gray-950 to-black py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-600">
              Media & Interactions
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Sharing insights and experiences with the filmmaking community
          </p>
        </div>

        {/* Interactions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {mockData.mediaInteractions.map((interaction, index) => (
            <div
              key={interaction.id}
              className="group relative bg-gradient-to-br from-gray-900 to-black p-8 rounded-lg border border-gray-800 hover:border-amber-400/50 transition-all duration-500 overflow-hidden"
            >
              {/* Background Glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-amber-400/0 to-amber-400/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Icon */}
              <div className="relative mb-6">
                {index === 0 ? (
                  <div className="w-16 h-16 rounded-full bg-amber-400/10 flex items-center justify-center group-hover:bg-amber-400/20 transition-all">
                    <Mic className="text-amber-400" size={28} />
                  </div>
                ) : (
                  <div className="w-16 h-16 rounded-full bg-amber-400/10 flex items-center justify-center group-hover:bg-amber-400/20 transition-all">
                    <GraduationCap className="text-amber-400" size={28} />
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="relative space-y-4">
                <h3 className="text-2xl font-bold text-white group-hover:text-amber-400 transition-colors">
                  {interaction.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {interaction.description}
                </p>
                <div className="flex items-center space-x-2 text-amber-400 text-sm font-semibold">
                  <span className="w-2 h-2 rounded-full bg-amber-400"></span>
                  <span>{interaction.year}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Featured Image Section */}
        <div className="mt-16 relative rounded-lg overflow-hidden">
          <img
            src={mockData.director.colorImage}
            alt="Rrammy at public speaking event"
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-8">
            <p className="text-white text-lg font-light">
              Engaging with aspiring filmmakers and industry professionals
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaInteractions;